import utils from "../helpers/utils";

/**
 * In most cases the aside with person picture will be aligned nicely with CSS.
 * However content might vary, so this code ensures perfect alignment, always.
 */

function init(): void {
  if (!utils.isMobile()) {
    const alignEl: HTMLElement = document.querySelector(".js-person-bio-align");
    if (alignEl) {
      const alignTo = alignEl.getAttribute("data-align-to");
      const alignToWrapper = alignEl.getAttribute("data-align-to-wrapper");
      if (alignTo && alignToWrapper) {
        const alignToEl = document.querySelector(alignTo);
        const alignToHeight = document.querySelector(alignToWrapper).getBoundingClientRect().height;
        alignEl.style.marginTop = -alignToHeight + (alignToEl as HTMLElement).offsetTop + "px";
      }
    }
  }
}

export default { init };
